import script from "./AiActions.vue?vue&type=script&setup=true&lang=js"
export * from "./AiActions.vue?vue&type=script&setup=true&lang=js"

import "./AiActions.vue?vue&type=style&index=0&id=0958ebee&lang=scss&scoped=true"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0958ebee"]])

export default __exports__